module.exports = __webpack_public_path__ + "open-graph.zd8GjeaQ.png";